// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"FormElement_wrapperComponent__v2NNw","formElementHalfWidth":"FormElement_formElementHalfWidth__49ve3"};